module.exports = __webpack_public_path__ + "static/media/7_desktop.dab5b73d.gif";